"use client";

import PointsLoader from "@/app/(components)/generics/loaders/PointsLoader/PointsLoader";
import styles from "./ModalLoader.module.css";

export default function ModalLoader() {
  return (
    <div className={styles.loader}>
      <PointsLoader color="var(--color-green-3)" />
    </div>
  );
}
